export const resolveCurrentSpaceShorthands = (
	rawCql: string,
	currentSpaceKey: string | undefined,
): string => {
	if (!rawCql || currentSpaceKey == undefined) {
		return rawCql;
	}
	// Matches both bare and quoted variants of the `currentSpace()` sentinel,
	// tolerating optional whitespace before/inside the parentheses (e.g.
	// `currentSpace ( )`). Some macro authors / older clients persist
	// `"currentSpace()"` as a string literal, so we accept both forms.
	return rawCql.replace(/"?currentSpace\s*\(\s*\)"?/g, () => {
		return `"${currentSpaceKey}"`;
	});
};
